import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface ToastListContent {
  header: string;
  intro?: string;
  items?: string[];
}

// rendered by ngx-sonner (via NgComponentOutlet) in place of a plain-text toast
// description, for toasts that need labeled/list-style content.
@Component({
    selector: 'app-toast-content',
    templateUrl: './toast-content.component.html',
    styleUrls: ['./toast-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastContentComponent {
  @Input() content: ToastListContent;
}
